<template>
  <div class="bg-white">
    <Carousel class="text-center pt-20">
      <Slide v-for="slide in 1" :key="slide">
        <div
          class="text-white py-44 bg-cover bg-no-repeat bg-center w-full bg-img"
        >
          <div class="lg:px-60 justify-center">
            <p class="font-semibold text-3xl lg:text-6xl" style="color: white">
              Get Active, Stay Fit, and Enjoy Moments at X-Sportainment!
            </p>
          </div>
        </div>
      </Slide>

      <template #addons>
        <Navigation class="rounded-full bg-yellow-500" />
        <Pagination />
      </template>
    </Carousel>

    <section class="lapangan mx-auto w-full p-10 lg:p-20">
      <div class="text-3xl font-semibold font-primary">Lapangan</div>
      <p
        class="mt-10 text-neutral-700 font-normal text-sm font-primary hidden md:block sm:block justify-center"
      >
        {{ lapangan.desc }}
      </p>
      <div class="mt-10">
        <Carousel
          v-bind="settings"
          :breakpoints="breakpoints"
          :transition="500"
          :autoplay="2000"
        >
          <Slide v-for="slide in lapangan?.products" :key="slide" >
            <div
              class="relative w-[350px] h-[282px] mx-auto rounded-2xl overflow-hidden cursor-pointer backdrop-blur-md bg-white/10 border border-white/20 shadow-xl"
              @click="
                goToProduct(slide.id, slide.need_to_show_product_prices, true)
              "
            >
              <!-- Background image (blurred behind glass) -->
              <img
                class="absolute inset-0 w-full h-full object-cover"
                :src="url + slide.picture_path"
                alt=""
              />

              <!-- Optional overlay to darken image slightly -->
              <div class="absolute inset-0 bg-black/20"></div>

              <!-- Text content -->
              <div
                class="absolute bottom-5 left-5 right-5 bg-white/20 backdrop-blur-md border border-white/30 rounded-xl px-4 py-3 shadow-md"
              >
                <div
                  class="text-base font-semibold font-primary text-white drop-shadow-md leading-snug"
                >
                  {{ slide.name }}
                </div>
              </div>
            </div>
          </Slide>
          <template #addons>
            <Navigation class="rounded-full bg-yellow-500" />
          </template>
        </Carousel>
      </div>
      <div class="banner_tagline mt-5">
        <img
          src="../assets/images/banner_tagline.png"
          alt=""
          class="h-auto max-w-full"
        />
      </div>

      <div class="kelas mx-auto w-full mt-10">
        <div class="text-3xl font-semibold font-primary">Non-Membership</div>
        <p
          class="mt-10 text-neutral-700 font-normal text-sm font-primary hidden md:block sm:block justify-center"
        >
          {{ kelas?.desc }}
        </p>
        <div class="mt-10">
          <Carousel
            v-bind="settings"
            :breakpoints="breakpoints"
            :transition="500"
            :autoplay="2000"
          >
            <Slide v-for="slide in kelas?.products" :key="slide">
              <div
                class="relative w-[350px] h-[282px] mx-auto rounded-2xl overflow-hidden cursor-pointer backdrop-blur-md bg-white/10 border border-white/20 shadow-xl"
                @click="
                  goToProduct(slide.id, slide.need_to_show_product_prices, true)
                "
              >
                <!-- Background image (blurred behind glass) -->
                <img
                  class="absolute inset-0 w-full h-full object-cover"
                  :src="url + slide.picture_path"
                  alt=""
                />

                <!-- Optional overlay to darken image slightly -->
                <div class="absolute inset-0 bg-black/20"></div>

                <!-- Text content -->
                <div
                  class="absolute bottom-5 left-5 right-5 bg-white/20 backdrop-blur-md border border-white/30 rounded-xl px-4 py-3 shadow-md"
                >
                  <div
                    class="text-base font-semibold font-primary text-white drop-shadow-md leading-snug"
                  >
                    {{ slide.name }}
                  </div>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation class="rounded-full bg-yellow-500" />
            </template>
          </Carousel>
        </div>
      </div>
      <div class="banner_trainer mt-5">
        <img
          src="../assets/images/banner_trainer.png"
          alt=""
          class="h-auto max-w-full"
        />
      </div>
      <div class="kelas mx-auto w-full mt-10">
        <div class="text-3xl font-semibold font-primary">Trainer</div>
        <p
          class="mt-10 text-neutral-700 font-normal text-sm font-primary hidden md:block sm:block justify-center"
        >
          X-Sportainment memiliki Trainer yang telah berpengalaman dibidang nya.
          Kami yakin dengan trainer yang memiliki kapasitas dan keahlian anda
          dapat memperoleh manfaat untuk kesehatan, kebugaran serta meningkatkan
          kebahagian jasmani & rohani anda.
        </p>
        <div class="mt-10">
          <Carousel
            v-bind="settings"
            :breakpoints="breakpoints"
            :transition="500"
            :autoplay="2000"
          >
            <Slide v-for="slide in trainers" :key="slide">
              <div
                class="relative w-[350px] h-[282px] mx-auto rounded-2xl overflow-hidden cursor-pointer backdrop-blur-md bg-white/10 border border-white/20 shadow-xl"
              >
                <!-- Background image (blurred behind glass) -->
                <img
                  class="absolute inset-0 w-full h-full object-cover"
                  :src="url + slide.picture_path"
                  alt=""
                />

                <!-- Optional overlay to darken image slightly -->
                <div class="absolute inset-0 bg-black/20"></div>

                <!-- Text content -->
                <div
                  class="absolute bottom-5 left-5 right-5 bg-white/20 backdrop-blur-md border border-white/30 rounded-xl px-4 py-3 shadow-md"
                >
                  <div
                    class="text-base font-semibold font-primary text-white drop-shadow-md leading-snug"
                  >
                    {{ slide.person.name }}
                  </div>
                </div>
              </div>
            </Slide>
            <template #addons>
              <Navigation class="rounded-full bg-yellow-500" />
            </template>
          </Carousel>
        </div>
      </div>
      <div class="banner_membership p-10 mt-5 h-auto">
        <img
          class="h-auto max-w-full"
          src="../assets/images/banner_membership.png"
          alt=""
          @click="goToPage()"
        />
      </div>

      <div class="membership mx-auto w-full mt-10">
        <div
          class="text-2xl lg:text-3xl font-semibold font-primary text-center"
        >
          Membership ?
        </div>
        <div class="pl-20 pr-20">
          <p
            class="text-center mt-10 text-neutral-700 font-normal text-sm font-primary hidden md:block sm:block justify-center"
          >
            {{ membership.desc }}
          </p>
        </div>
        <div class="flex flex-col items-center mt-10">
          <div
            class="h-10 bg-amber-500 rounded text-center items-center gap-2 inline-flex"
          >
            <button
              class="w-[200px] self-stretch px-4 py-2.5 justify-center items-center gap-2 flex"
              @click="goToPage()"
            >
              <div
                class="text-center text-neutral-700 text-base font-semibold leading-normal"
                style="font-size: 14px !important"
              >
                Lihat detail
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>

    <Teleport to="body">
      <Transition
        enter-active-class="transition-opacity duration-300"
        enter-from-class="opacity-0"
        leave-active-class="transition-opacity duration-200"
        leave-to-class="opacity-0"
      >
        <!-- Root modal wrapper -->
        <div
          v-if="isModal"
          class="fixed inset-0 z-50 flex items-center justify-center"
          tabindex="0"
          @keydown.esc="isModal = false"
        >
          <!-- Dark overlay -->
          <div
            class="absolute inset-0 bg-black/60 backdrop-blur-sm"
            @click="isModal = false"
          ></div>

          <!-- Modal container -->
          <div
            class="relative w-full max-w-[90vw] mx-4"
            @click.self="isModal = false"
          >
            <!-- Close button -->
            <button
              class="absolute -top-3 -right-3 bg-white rounded-full shadow p-1 hover:rotate-90 transition"
              @click="isModal = false"
              aria-label="Tutup"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            <!-- Promo image: sekarang full (contain) -->

            <Swiper
              :modules="modules"
              :slides-per-view="1"
              :space-between="50"
              navigation
              :pagination="{ clickable: true }"
              :scrollbar="{ draggable: true }"
               :autoplay="{ delay: 5000, disableOnInteraction: false }"
              :loop="events.length > 1"
              class="w-full h-auto max-h-[90vh] rounded-xl overflow-hidden shadow-lg"
            >
              <SwiperSlide v-for="(img, index) in events" :key="index">
                <img
                  v-if="date_now > img.started_at && date_now < img.ended_at"
                  :src="url + img.picture"
                  alt="Slide"
                  class="w-full h-auto object-contain max-h-[90vh]"
                  @click="isModal = false"
                />
              </SwiperSlide>
            </Swiper>
            <!-- <img
             :src="url+event.picture"
             @click="isModal = false"
            alt="Promo Spesial"
            class="w-full h-auto max-h-[90vh] object-contain rounded-xl shadow-lg"
          /> -->
          </div>
        </div>
      </Transition>
    </Teleport>
  </div>
</template>
<style>
.bg-img {
  background-image: linear-gradient(
      to left,
      rgba(227, 153, 35, 0.5),
      rgba(227, 153, 35, 0.5)
    ),
    url("../assets/images/bg-hero-slide.png");
}
.carousel__slide {
  padding: 5px;
}
</style>
<script>
import ApiService from "@/services/api.service";
import AuthService from "@/services/auth.service";
import productService from "@/services/product.service";
import { webUrl } from "../utils/config";
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import moment from "moment";
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation as navigations, Pagination, Scrollbar, Autoplay } from 'swiper/modules';
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
export default {
  name: "Home",
  components: {
    Carousel,
    Slide,
    Navigation,
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      date_now: "",
      isModal: false,
      url: webUrl,
      location_id: "",
      tenant: {},
      lapangan: {},
      kelas: {},
      trainers: [],
      membership: {},
      events: [],
      modules: [navigations, Pagination, Scrollbar,Autoplay],
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      // breakpoints are mobile first
      // any settings not specified will fallback to the carousel settings
      breakpoints: {
        // 700px and up
        700: {
          itemsToShow: 3.5,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 5,
          snapAlign: "start",
        },
      },
    };
  },
  computed: {},
  mounted() {
    this.getDateTimeNow();
    AuthService.getDataTenant().then(
      (response) => {
        var data = response.data;
        this.tenant = data;
        this.getLocation();
        this.getCategoryLapangan();
        this.getCategoryKelas();
        this.getTrainer();
        this.getCategoryMembership();
        this.getEvent(this.tenant.id);
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
  methods: {
    onSwiper(swiper){
      console.log(swiper);
    },
    onSlideChange(){
      console.log('slide change');
    },
    getDateTimeNow() {
      var dateTime = "";
      const today = new Date();
      const time = today.getHours() + ":00";
      dateTime =
        moment().format("YYYY-MM-DD") +
        " " +
        moment(time, "HH:mm:ss").format("HH:mm");

      this.date_now = dateTime;
    },
    getEvent(tenantId) {
      productService.getEvent(tenantId).then(
        (response) => {
          var data = response.data.data;
          if (data.length > 0) {
            this.isModal = true;
            this.events = data;
          }

          //   this.isModal = true;
          // for (let i = 0; i < data.length; i++) {
          //     //
          //     if(this.date_now  > data[i].started_at && this.date_now < data[i].ended_at){
          //       this.event = data[i]
          //       this.isModal = true;
          //       // console.log(true);
          //     }else{
          //       this.isModal = false;
          //       // console.log(false);
          //     }

          // }
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getLocation() {
      ApiService.getDataLocation(this.tenant.id).then(
        (response) => {
          var data = response.data;
          this.locations = data;
          if (this.location_id == "") {
            this.location_id = this.locations[0].id;
          }
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getCategoryLapangan() {
      productService.getDataProductsByName(this.tenant.id, "lapangan").then(
        (response) => {
          var data = response.data.data;
          this.lapangan = data[0];
          // console.log(data[0].products);
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getCategoryKelas() {
      productService.getDataProductsByName(this.tenant.id, "Non-Membership").then(
        (response) => {
          var data = response.data.data;
          this.kelas = data[0];
          // console.log(data[0].products);
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getTrainer() {
      productService.getTrainer(this.tenant.id).then(
        (response) => {
          var data = response.data.data;

          this.trainers = data;
          this.isLoading = false;
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    getCategoryMembership() {
      productService.getDataProductsByName(this.tenant.id, "membership").then(
        (response) => {
          var data = response.data.data;
          this.membership = data[0];
          // console.log(data[0].products);
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
        }
      );
    },
    goToProduct(Id, showPrices, isProductPrices) {
      // console.log(totalPoductPrice);
      if (showPrices == true && isProductPrices == true) {
        this.$router
          .push({
            name: "product-detail",
            query: {
              location_id: this.location_id,
              product_id: Id,
            },
          })
          .then((response) => {
            location.reload();
          });
      } else {
        this.$router
          .push({
            name: "book-product",
            query: {
              location_id: this.location_id,
              product_id: Id,
            },
          })
          .then((response) => {
            location.reload();
          });
      }
    },
    goToPage() {
      if (this.membership != null) {
        this.$router
          .push({
            name: "category",
            query: {
              categoryId: this.membership.id,
            },
          })
          .then((response) => {
            location.reload();
          });
      }
    },
  },
};
</script>
